// ------- C NBK ------
$(document).ready(function(){
  
// go to product tabbing
$('body').on('click','.select_product, #goToBottomSection',function(e){
  e.preventDefault();
  $('html, body').animate({
      scrollTop: $(".shop_all_tabing").offset().top - $("header.header").height() - 30
  }, 500);
});



  
let allItem = [];
  
// add to bundle click 
$('body').on('click','.cart_option_btn',function(e){
      var nexttab = $('.shop_tabs_slider .swiper-slide.current').next().length;
console.log(nexttab,"nexttab")
  if (nexttab === 0) {
     $('.shop_tabs_slider .swiper-slide:first').trigger('click');
  } else {
    $('.shop_tabs_slider .swiper-slide.current').next().trigger('click');
  }

    e.preventDefault();
    var item = [];
    item.itemIMG = $(this).parent('.tabs_cart_btn').attr('data-item-img')
    item.itemTitle = $(this).parent('.tabs_cart_btn').attr('data-item-title')
    item.itemCVarianttitle = $(this).parent('.tabs_cart_btn').attr('data-item-CVariant-title')
    item.itemURL = $(this).parent('.tabs_cart_btn').attr('data-item-url')
    item.itemPrice = $(this).parent('.tabs_cart_btn').attr('data-item-price')
    item.itemCPrice = $(this).parent('.tabs_cart_btn').attr('data-item-cprice')
    item.itemCVariant = $(this).parent('.tabs_cart_btn').prev().val();
    allItem.push(item);
    var NewHTML = allItem;
    UpdateHTML(NewHTML);
});


// remove bundle item click 
function removeItem(){
$('body').on('click', '.bundle-product-badge-delete', function(e) {
    e.preventDefault();
    // Get the index from the data-item-index attribute and convert it to an integer
    var indexToRemove = parseInt($(this).attr('data-item-index'), 10);
    // Check if the index is valid
    if (indexToRemove > -1) {
        // Remove the item at the specified index
        allItem.splice(indexToRemove, 1);
    }
    UpdateHTML(allItem);
});
}
removeItem();

// price update 
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};
function updatePrice(){
  if ($('.bundle-item-header-price').length > 1) {
      $(".bundle-summary-payment .bundle-summary_add").removeClass("disabled");
  }else{
    $(".bundle-summary-payment .bundle-summary_add").addClass("disabled");
  }

  
  var totalPrice = 0;
  // Iterate through each element with the class 'bundle-item-header-price'
  $('.bundle-item-header-price').each(function() {
      // Extract the price, assuming it's a numeric value within the element
      var priceText = $(this).text().trim(); // Get the text content and trim any extra spaces
      var price = parseFloat(priceText.replace(/[^0-9.-]+/g,"")); // Remove any non-numeric characters and convert to a float
  
      // Add the price to the total, if it's a valid number
      if (!isNaN(price)) {
          totalPrice += price;
      }

         var itemLength = $('.bundle-item-header-price').length;
    var shop_money_format = $('body').attr('data-shop-moneyformat');
    var totaldis = totalPrice * 100;
          
           if (itemLength == 1 ) {
              var minusdis = totalPrice - twoitemdisc;
             $('.bundle-summary_discountCalc , .bundle-summary_discount').removeClass('active_discount');
                  $('.bundle-summary_discount').html(discount_unloc_text);
              $('.discount-price-container .total').removeClass('compare_price');
              $('.discount-price-container .discount').hide();
              $('.bundle-summary_discountCalc_amount').text( Shopify.formatMoney(0,shop_money_format));
           } else if (itemLength == 2) {
              var minusdis = totalPrice - twoitemdisc;
              var finaldisc = minusdis * 100;
              var plusdis = twoitemdisc * 100;
             $('.bundle-summary_discountCalc , .bundle-summary_discount').addClass('active_discount');
              $('.bundle-summary_discount').html('Awesome! You are saving '+ Shopify.formatMoney(plusdis,shop_money_format));
              $('.discount-price-container .total').addClass('compare_price');
              $('.discount-price-container .discount').show().text( Shopify.formatMoney(finaldisc,shop_money_format));
              $('.bundle-summary_discountCalc_amount').text( Shopify.formatMoney(plusdis,shop_money_format));
            } else if (itemLength == 3) {
              var minusdis = totalPrice - threeitemdisc;
              var finaldisc = minusdis * 100;
               var plusdis = threeitemdisc * 100;
             $('.bundle-summary_discountCalc , .bundle-summary_discount').addClass('active_discount');
              $('.bundle-summary_discount').html('Awesome! You are saving '+ Shopify.formatMoney(plusdis,shop_money_format));
              $('.discount-price-container .total').addClass('compare_price');
              $('.discount-price-container .discount').show().text( Shopify.formatMoney(finaldisc,shop_money_format));
              $('.bundle-summary_discountCalc_amount').text( Shopify.formatMoney(plusdis,shop_money_format));
            }  else if (itemLength == 4) {
             var minusdis = totalPrice - fouritemdisc;
              var finaldisc = minusdis * 100;
              var plusdis = fouritemdisc * 100;
             $('.bundle-summary_discountCalc , .bundle-summary_discount').addClass('active_discount');
               $('.bundle-summary_discount').html('Awesome! You are saving '+ Shopify.formatMoney(plusdis,shop_money_format));
              $('.discount-price-container .total').addClass('compare_price');
              $('.discount-price-container .discount').show().text( Shopify.formatMoney(finaldisc,shop_money_format));
              $('.bundle-summary_discountCalc_amount').text( Shopify.formatMoney(plusdis,shop_money_format));
            } else if (itemLength >= 5) {
              var minusdis = totalPrice - fiveitemdisc;
              var finaldisc = minusdis * 100;
              var plusdis = fiveitemdisc * 100;
             $('.bundle-summary_discountCalc , .bundle-summary_discount').addClass('active_discount');
               $('.bundle-summary_discount').html('Awesome! You are saving '+ Shopify.formatMoney(plusdis,shop_money_format));
              $('.discount-price-container .total').addClass('compare_price');
              $('.discount-price-container .discount').show().text( Shopify.formatMoney(finaldisc,shop_money_format));
              $('.bundle-summary_discountCalc_amount').text( Shopify.formatMoney(plusdis,shop_money_format));
            }

    $('.discount-price-container .total').text( Shopify.formatMoney(totalPrice.toFixed(2),shop_money_format)); // Assuming you have an element with id 'total-price'
  });
var shop_money_format = $('body').attr('data-shop-moneyformat');
$('.discount-price-container .total').text( Shopify.formatMoney(totalPrice.toFixed(2),shop_money_format)); // Assuming you have an element with id 'total-price'

}
  
// update all HTML

function UpdateHTML(NewHTML){
    var productLikeHtml = '';
    var newItem = '';
    var tickHTML = '';
    productLikeHtml += '<div class="choose_product_wpr swiper"><div class="swiper-wrapper">'
    $.each(NewHTML, function( index, item ) {
        var numberr = index + 1;
        productLikeHtml += '<div class="swiper-slide"><div class="choose_product_col"><div class="bundle-product-card"><div class="bundle-action-wp"><div class="bundle-product-badge-delete" data-item-index="'+index+'" data-item-id="'+item.itemCVariant+'">Remove</div></div><div class="bundle-product-img-wp"><div class="bundle-product-img">  <img src="'+item.itemIMG+'" alt="">    </div><div class="product-title">  <p>'+item.itemTitle+'</p> <span class="itemCVarianttitle">'+item.itemCVarianttitle+'</span>   </div></div><div class="bundle-product-bottom"><div class="bundle-product-price"><div class="discount"><div class="msrp">'+item.itemCPrice+'</div>  </div><div class="total">'+item.itemPrice+'</div>    </div></div></div></div></div>'
        newItem += '<div class="bundle-item"><div class="bundle-item-header"><div class="bundle-item-header-title">'+item.itemTitle+'</div><div class="bundle-item-header-price">'+item.itemPrice+'</div></div></div>'
        tickHTML+= '<div class="emptyProduct active"><div class="emptyProduct_inn"><img src="https://cdn.shopify.com/s/files/1/0549/2618/0530/files/checked-icon-blue.svg?v=1723463026"><div class="emptyProduct_text"><p>Item '+numberr+'</p></div></div></div>'
    });
    console.log("ewHTML.length", NewHTML.length)
      if (NewHTML.length == 0) {
         productLikeHtml +='<div class="swiper-slide"><div class="choose_product_col"><div class="choose_product_block"><a href="#" class="select_product active">Choose 1st appliance</a></div></div></div><div class="swiper-slide"><div class="choose_product_col"><div class="choose_product_block"><a href="#" class="select_product">Choose 1st appliance</a></div></div></div><div class="swiper-slide"><div class="choose_product_col"><div class="choose_product_block"><a href="#" class="select_product">Choose 2nd appliance</a></div></div></div><div class="swiper-slide"><div class="choose_product_col"><div class="choose_product_block"><a href="#" class="select_product">Choose 3rd appliance</a></div></div></div>'
         tickHTML+= '<div class="emptyProduct"><div class="emptyProduct_inn"><img src="https://cdn.shopify.com/s/files/1/0549/2618/0530/files/unchecked-icon-grey.svg?v=1723008504"><div class="emptyProduct_text"><p>Item 1</p></div></div></div><div class="emptyProduct"><div class="emptyProduct_inn"><img src="https://cdn.shopify.com/s/files/1/0549/2618/0530/files/unchecked-icon-grey.svg?v=1723008504"><div class="emptyProduct_text"><p>Item 2</p></div></div></div><div class="emptyProduct"><div class="emptyProduct_inn"><img src="https://cdn.shopify.com/s/files/1/0549/2618/0530/files/unchecked-icon-grey.svg?v=1723008504"><div class="emptyProduct_text"><p>Item 3</p></div></div></div><div class="emptyProduct"><div class="emptyProduct_inn"><img src="https://cdn.shopify.com/s/files/1/0549/2618/0530/files/unchecked-icon-grey.svg?v=1723008504"><div class="emptyProduct_text"><p>Item 4</p></div></div></div>'
      } else if (NewHTML.length == 1) {
           productLikeHtml +='<div class="swiper-slide"><div class="choose_product_col"><div class="choose_product_block"><a href="#" class="select_product active">Choose 2nd appliance</a></div></div></div><div class="swiper-slide"><div class="choose_product_col"><div class="choose_product_block"><a href="#" class="select_product">Optional: Choose 3rd appliance</a></div></div></div><div class="swiper-slide"><div class="choose_product_col"><div class="choose_product_block"><a href="#" class="select_product">Choose 4th appliance</a></div></div></div>'
           tickHTML+= '<div class="emptyProduct"><div class="emptyProduct_inn"><img src="https://cdn.shopify.com/s/files/1/0549/2618/0530/files/unchecked-icon-grey.svg?v=1723008504"><div class="emptyProduct_text"><p>Item 2</p></div></div></div><div class="emptyProduct"><div class="emptyProduct_inn"><img src="https://cdn.shopify.com/s/files/1/0549/2618/0530/files/unchecked-icon-grey.svg?v=1723008504"><div class="emptyProduct_text"><p>Item 3</p></div></div></div><div class="emptyProduct"><div class="emptyProduct_inn"><img src="https://cdn.shopify.com/s/files/1/0549/2618/0530/files/unchecked-icon-grey.svg?v=1723008504"><div class="emptyProduct_text"><p>Item 4</p></div></div></div>'
      } else if (NewHTML.length == 2) {
          productLikeHtml +='<div class="swiper-slide"><div class="choose_product_col"><div class="choose_product_block"><a href="#" class="select_product active">Optional: Choose 3rd appliance</a></div></div></div><div class="swiper-slide"><div class="choose_product_col"><div class="choose_product_block"><a href="#" class="select_product">Optional: Choose 4th appliance</a></div></div></div>'
          tickHTML+= '<div class="emptyProduct"><div class="emptyProduct_inn"><img src="https://cdn.shopify.com/s/files/1/0549/2618/0530/files/unchecked-icon-grey.svg?v=1723008504"><div class="emptyProduct_text"><p>Item 3</p></div></div></div><div class="emptyProduct"><div class="emptyProduct_inn"><img src="https://cdn.shopify.com/s/files/1/0549/2618/0530/files/unchecked-icon-grey.svg?v=1723008504"><div class="emptyProduct_text"><p>Item 4</p></div></div></div>'
      } else if (NewHTML.length == 3) {
          productLikeHtml += '<div class="swiper-slide"><div class="choose_product_col"><div class="choose_product_block"><a href="#" class="select_product active">Optional: Choose 4th appliance</a></div></div></div>'
          tickHTML+= '<div class="emptyProduct"><div class="emptyProduct_inn"><img src="https://cdn.shopify.com/s/files/1/0549/2618/0530/files/unchecked-icon-grey.svg?v=1723008504"><div class="emptyProduct_text"><p>Item 4</p></div></div></div>'
      } else{
          productLikeHtml += '<div class="swiper-slide"><div class="choose_product_col"><div class="choose_product_block"><a href="#" class="select_product active">Choose more appliance</a></div></div></div>'
      }
        productLikeHtml += '</div><div class="swiper-button-prev choose_product_arrow"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M 7.75 1.34375 L 6.25 2.65625 L 14.65625 12 L 6.25 21.34375 L 7.75 22.65625 L 16.75 12.65625 L 17.34375 12 L 16.75 11.34375 Z"></path></svg></div><div class="swiper-button-next choose_product_arrow"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M 7.75 1.34375 L 6.25 2.65625 L 14.65625 12 L 6.25 21.34375 L 7.75 22.65625 L 16.75 12.65625 L 17.34375 12 L 16.75 11.34375 Z"></path></svg></div></div>'

    $('.choose_product_left').html(productLikeHtml);
    $('.bundle-summary-items').html(newItem);
    $('.bundle-summary-content-productAvatar').html(tickHTML);
    
    var swiper = new Swiper(".choose_product_wpr", {
    slidesPerView:4,
    spaceBetween: 30,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
        1366: {
          slidesPerView: 4,
        },
        1280: {
          slidesPerView: 3,
        },
        992: {
          slidesPerView: 2,
        },
        690: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        300: {
          slidesPerView: 2,
        },
    },
  });

// go to top products div 
$('html, body').animate({
    scrollTop: $(".choose_product_main").offset().top - $("header.header").height() - 30
}, 500);

  
// go to product tabbing
$('body').on('click','.select_product',function(e){
  e.preventDefault();
  $('html, body').animate({
      scrollTop: $(".shop_all_tabing").offset().top - $("header.header").height() - 30
  }, 500);
});
  
updatePrice();
allItem = NewHTML
}

// ------------------ bundle product add to cart
function getRandomNumber(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}
  $('body').on('click', '.bundle-summary_add', function(event) {
  
  event.preventDefault(); 
  let unique_no = getRandomNumber(10000000000,10000000000000);
  var selectedProducts = {
    items:[]
  }
  $('.bundle-product-badge-delete').each(function() {
    var json={};
    var get_id = $(this).attr('data-item-id');
    var get_quantity = "1";
    var get_propertiess = {
      "Propertiesbundle" : unique_no,
    };
    json['id'] = get_id;
    json['quantity']= get_quantity;
    json['properties']= get_propertiess;
    selectedProducts.items.push(json);
  })  
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: selectedProducts,
    dataType: 'json',
    success: function(data) {
       window.location.href = "/checkout";
    },
    error: function(data) {
      alert(data.responseJSON.description);
    }
  });
});
});


